<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="门店名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入门店名称"></Input>
      </FormItem>
      <FormItem label="地址" prop="location">
        <Input v-model="formValidate.location" placeholder="请输入地址"></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      formValidate: {
        id: '',
        name: '',
        location: '',
        factoryUserId:"1"
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '门店名称必须填写',
            trigger: 'blur'
          }
        ],
        location: [
          {
            required: true,
            message: '门店地址必须填写',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.name = data.name
      this.formValidate.location = data.location
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
